/* Alfara Estética — confeti de Fiestas Patrias
 *
 * Cae una sola vez por visita (sessionStorage), dura ~5 s y se borra sola.
 * Reglas que NO se tocan sin volver a pensarlas:
 *   - `prefers-reduced-motion: reduce` → no cae nada. Hay gente con vértigo y
 *     trastornos vestibulares; una lluvia de partículas les arruina la página.
 *   - `pointer-events: none` y el canvas se destruye al terminar: no puede
 *     quedar una capa invisible tapando los botones de compra.
 *   - Se detiene si la pestaña pasa a segundo plano (no quema batería).
 *   - Todo acceso a sessionStorage va en try/catch: en navegación privada o con
 *     cookies bloqueadas, `sessionStorage` lanza excepción al leerlo.
 *
 * Piezas: confeti rectangular, banderitas de Chile y copihues. Las tres se
 * dibujan con canvas — sin imágenes, sin librerías, ~4 KB.
 */
(function () {
  'use strict';

  var CLAVE = 'alfara-fp-confeti';
  var DURACION = 5200;      // ms de emisión + caída
  var cfg = window.AlfaraConfeti || {};
  var SIEMPRE = cfg.siempre === true;   // para previsualizar en el editor de temas

  function permitido() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return false;
    }
    if (SIEMPRE) return true;
    try {
      if (sessionStorage.getItem(CLAVE)) return false;
      sessionStorage.setItem(CLAVE, '1');
    } catch (e) {
      /* sin storage: cae igual, una vez por carga */
    }
    return true;
  }

  var ROJO = '#D52B1E';
  var AZUL = '#0039A6';
  var BLANCO = '#FFFFFF';
  var TEAL = '#0B5C6B';
  var CELESTE = '#1EB8DF';
  var COLORES = [ROJO, AZUL, BLANCO, TEAL, CELESTE, ROJO, BLANCO];

  function estrella(ctx, r) {
    ctx.beginPath();
    for (var i = 0; i < 10; i++) {
      var radio = i % 2 === 0 ? r : r * 0.4;
      var a = -Math.PI / 2 + (i * Math.PI) / 5;
      var x = Math.cos(a) * radio;
      var y = Math.sin(a) * radio;
      i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.closePath();
    ctx.fill();
  }

  function dibujarBandera(ctx, w) {
    var h = w * 0.66;
    ctx.fillStyle = BLANCO;
    ctx.fillRect(-w / 2, -h / 2, w, h / 2);
    ctx.fillStyle = ROJO;
    ctx.fillRect(-w / 2, 0, w, h / 2);
    ctx.fillStyle = AZUL;
    ctx.fillRect(-w / 2, -h / 2, w / 3, h / 2);
    ctx.save();
    ctx.translate(-w / 2 + w / 6, -h / 4);
    ctx.fillStyle = BLANCO;
    estrella(ctx, w * 0.10);
    ctx.restore();
  }

  function dibujarCopihue(ctx, r) {
    ctx.fillStyle = ROJO;
    for (var k = -2; k <= 2; k++) {
      ctx.save();
      ctx.rotate(k * 0.24);
      ctx.beginPath();
      ctx.ellipse(0, r * 0.55, r * 0.24, r * 0.62, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
    ctx.fillStyle = '#8C1610';
    ctx.beginPath();
    ctx.arc(0, 0, r * 0.16, 0, Math.PI * 2);
    ctx.fill();
  }

  function arrancar() {
    var lienzo = document.createElement('canvas');
    lienzo.setAttribute('aria-hidden', 'true');
    lienzo.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;' +
      'transition:opacity .7s ease';
    document.body.appendChild(lienzo);

    var ctx = lienzo.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H;

    function medir() {
      W = lienzo.clientWidth;
      H = lienzo.clientHeight;
      lienzo.width = W * dpr;
      lienzo.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    medir();
    window.addEventListener('resize', medir);

    // menos piezas en pantallas chicas: es donde está casi todo el tráfico
    var total = W < 700 ? 70 : 130;
    var piezas = [];
    for (var i = 0; i < total; i++) {
      var dado = Math.random();
      piezas.push({
        x: Math.random() * W,
        y: -Math.random() * H * 0.9 - 20,
        vx: (Math.random() - 0.5) * 1.1,
        vy: 1.6 + Math.random() * 2.6,
        giro: Math.random() * Math.PI * 2,
        vgiro: (Math.random() - 0.5) * 0.16,
        tam: 7 + Math.random() * 9,
        color: COLORES[(Math.random() * COLORES.length) | 0],
        tipo: dado < 0.62 ? 'confeti' : dado < 0.86 ? 'bandera' : 'copihue',
        bamboleo: Math.random() * Math.PI * 2
      });
    }

    var inicio = null;
    var raf = null;

    function cuadro(t) {
      if (inicio === null) inicio = t;
      var transcurrido = t - inicio;
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < piezas.length; i++) {
        var p = piezas[i];
        p.bamboleo += 0.05;
        p.x += p.vx + Math.sin(p.bamboleo) * 0.7;
        p.y += p.vy;
        p.giro += p.vgiro;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.giro);
        if (p.tipo === 'bandera') {
          dibujarBandera(ctx, p.tam * 1.9);
        } else if (p.tipo === 'copihue') {
          dibujarCopihue(ctx, p.tam * 0.95);
        } else {
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.tam / 2, -p.tam / 4, p.tam, p.tam / 2);
        }
        ctx.restore();
      }

      if (transcurrido < DURACION) {
        raf = requestAnimationFrame(cuadro);
      } else {
        limpiar();
      }
    }

    function limpiar() {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', medir);
      document.removeEventListener('visibilitychange', alOcultar);
      lienzo.style.opacity = '0';
      setTimeout(function () {
        if (lienzo.parentNode) lienzo.parentNode.removeChild(lienzo);
      }, 750);
    }

    function alOcultar() {
      if (document.hidden) limpiar();
    }
    document.addEventListener('visibilitychange', alOcultar);

    raf = requestAnimationFrame(cuadro);
  }

  function listo() {
    if (permitido()) arrancar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', listo);
  } else {
    listo();
  }
})();
